'use client';

import { AppRoute } from 'apps/woundscantwait-com/src/libs/enums/app-route.enum';
import { usePathname } from 'next/navigation';
import { FC, PropsWithChildren } from 'react';
import {
  SafityInformationSection,
  ApligrafSafetyInformationSection,
} from '../../../../_libs/sections/sections';

const HealingNavigatorSafityInformation: FC = () => {
  const pathname = usePathname();

  const isHealingNavigator = pathname === AppRoute.HEALING_NAVIGATOR;

  if (isHealingNavigator) {
    return <SafityInformationSection />;
  }

  return <ApligrafSafetyInformationSection />;
};

export { HealingNavigatorSafityInformation };
